import classNames from "classnames";
import moment from "moment";
import React from "react";
import { Control } from "react-redux-form";
import _ = require("underscore");
import { createDateFromParts, getDayOfMonth, getMonth, getYear } from "@travellocal/utils/dateHelpers";

interface IDateOfBirthPickerProps {
  onChange: (date: IDate) => any;
  value: IDate;
  className?: string;
}

interface IDateOfBirthPickerState {
  day: string;
  month: string;
  year: string;
}

class PickerComponent extends React.Component<IDateOfBirthPickerProps, IDateOfBirthPickerState> {
  constructor(props) {
    super(props);

    this.state = { day: null, month: null, year: null };

    if (this.props.value) {
      const date = this.props.value;
      this.state = {
        day: getDayOfMonth(date).toString(),
        month: getMonth(date).toString(), // 1..12
        year: getYear(date).toString(),
      };
    }
  }

  private isSelectionValid = () => {
    const { onChange } = this.props;
    const { day, month, year }  = this.state;
    const dayAsInt = parseInt(day, 10);
    const monthAsInt = parseInt(month, 10);
    const yearAsInt = parseInt(year, 10);

    if (Number.isInteger(dayAsInt) && Number.isInteger(monthAsInt) && Number.isInteger(yearAsInt)) {
      const date = createDateFromParts(dayAsInt, monthAsInt, yearAsInt);
      onChange(date);
    } else {
      onChange(null);
    }
  }

  private onSelectChange = (dateType: string, value: string) => {
    // `as any` used to resolve bug in typescript not accepting dynamic keys https://github.com/DefinitelyTyped/DefinitelyTyped/issues/26635
    this.setState({ [dateType]: value } as any, this.isSelectionValid);
  }

  public render() {
    const { className } = this.props;
    const {
      day,
      month,
      year,
    } = this.state;
    const currentYear = moment().year();

    return(
      <div className={classNames("columns", className)}>
        <div className={classNames("column", "is-4")}>
          <select
            className={classNames({placeholder: day === null})}
            onChange={event => this.onSelectChange("day", (event.target as HTMLSelectElement).value)}
            defaultValue={day}
          >
            <option>Day...</option>
            {_.range(1, 32).map(i => (
              <option
                key={i}
                value={i}
              >{i}</option>),
            )}
          </select>
        </div>
        <div className={classNames("column", "is-4")}>
          <select
            className={classNames({placeholder: month === null})}
            onChange={event => this.onSelectChange("month", (event.target as HTMLSelectElement).value)}
            defaultValue={String(parseInt(month, 10))}
          >
            <option>Month...</option>
            {_.range(0, 12).map(i => {
              const calcMonth = moment().month(i);
              return (
                <option
                  key={i}
                  value={calcMonth.format("M")}
                >{calcMonth.format("MMMM")}</option>
              );
            })}
          </select>
        </div>
        <div className={classNames("column", "is-4")}>
          <select
            className={classNames({placeholder: year === null})}
            onChange={event => this.onSelectChange("year", (event.target as HTMLSelectElement).value)}
            defaultValue={year}
            >
              <option>Year...</option>
              {
                _.range(currentYear, currentYear - 110, -1).map(i => {
                  return (
                    <option
                      key={i}
                      value={i}
                    >{i}</option>
                  );
                })
              }
          </select>
        </div>
      </div>
    );
  }
}

interface WrapperProps {
  model: string;
  className?: string;
}

export const DateOfBirthPicker = ({ model, className }: WrapperProps) => {
  return (
    <Control.custom
      className={className}
      model={model}
      component={PickerComponent}
      mapProps={{
        onChange: (props) => props.onChange,
        value: (props) => props.modelValue || null,
      }}
    />
  );
};
